import { useEffect, useState } from 'react';
import { getAccessToken, getServiceAccessToken } from "../../services/authApi";
import { fieldReader, MoveLoanFolder } from "../../services/loanApi";
import ConfirmPrompt from '../shared/ConfirmPrompt';

const LoanCancelFolder = process.env.REACT_APP_WHL_LOAN_CANCEL_FOLDER ?? '';

const CancelLoan = ({ isWeb = false }) => {
    const [showRemoveAuConfirm, setShowRemoveAuConfirm] = useState(false);
    const [accessToken, setAccessToken] = useState();
    const [currentLoanId, setCurrentLoanId] = useState();
    const [currentLoanFolder, setCurrentLoanFolder] = useState();
    const [comment, setComment] = useState("");
    const [canceldBy, setCanceldBy] = useState("");
    const [canceldOn, setCanceldOn] = useState("");
    const [isLoanReadOnly, setIsLoanReadOnly] = useState(false);

    useEffect(() => {
        if (window.elli && window.elli.script && window.elli.script.guest) {
            window.elli.script.guest.create();
            initializeAuthObject();
        } else {
            console.warn("elli.script.guest is not available.");
        }
    }, []);

    const initializeAuthObject = async () => {
        try {
            const loanObject = await window.elli.script.getObject("loan");
            const loan = await loanObject.all();

            const tmpLoanId = loan?.loan?.id ?? loan.id;
            setCurrentLoanId(tmpLoanId);

            const isReadOnly = await loanObject.isReadOnly();
            setIsLoanReadOnly(isReadOnly);

            const tpoAuthObject = await window.elli.script.getObject("auth");
            const authCode = await tpoAuthObject.createAuthCode();
            const tmpAccessToken = await getAccessToken(authCode);
            setAccessToken(tmpAccessToken);

            const readFields = [
                "LOANFOLDER",
                "CX.LOAN.CANCEL.REASON",
                "CX.LOAN.CANCEL.BY",
                "CX.LOAN.CANCEL.DATETIME",
            ];
            const fieldData = await fieldReader(tmpAccessToken, readFields, tmpLoanId);
            setCurrentLoanFolder(fieldData["LOANFOLDER"] || '');
            setComment(fieldData["CX.LOAN.CANCEL.REASON"] || '');
            setCanceldBy(fieldData["CX.LOAN.CANCEL.BY"] || '');
            setCanceldOn(fieldData["CX.LOAN.CANCEL.DATETIME"] || '');
        } catch (error) {
            console.error("Auth block Error:", error);
        }
    };

    const cancelLoan = async () => {
        try {
            setShowRemoveAuConfirm(false);

            const tpoAuthObject = await window.elli.script.getObject("auth");
            const sAuthCode = await tpoAuthObject.createAuthCode();
            const serviceAccessToken = await getServiceAccessToken(sAuthCode);

            let tmpAccessToken;
            if (!accessToken) {
                const authCode = await tpoAuthObject.createAuthCode();
                tmpAccessToken = await getAccessToken(authCode);
            }
            await MoveLoanFolder(serviceAccessToken, currentLoanId, LoanCancelFolder, accessToken ?? tmpAccessToken, comment);

            if (!isWeb) {
                const tpoAppObject = await window.elli.script.getObject('tpoApplication');
                await tpoAppObject.pageRedirect('topNav', { section: 'welcome' });
            } else {
                const appObject = await window.elli.script.getObject('application');
                await appObject.navigate({ target: 'PIPELINE', type: "OTHER" });
            }
        } catch (error) {
            console.error("Error move loan folder:", error);
        }
    };

    const renderCancelLoanForm = () => {
        return (
            <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9] my-6">
                <div className="grid md:grid-cols-3 gap-6 mt-4 px-4 py-4">
                    <div className="w-full">
                        <label className="form-label">Cancel Reason</label>
                        <div className="relative w-full">
                            <textarea
                                className="form-input"
                                rows="3"
                                placeholder="Cancel Reason..."
                                value={comment}
                                maxLength={200}
                                readOnly={isLoanReadOnly}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <label className="form-label">Canceled By</label>
                        <div className="relative w-full">
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Canceled By..."
                                readOnly
                                value={canceldBy}
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <label className="form-label">Canceled On</label>
                        <div className="relative w-full">
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Canceled On..."
                                readOnly
                                value={canceldOn}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderCancelLoanButton = () => {
        return (
            <div>
                <button
                    className="py-2 px-3 bg-blue-500 text-white text-sm font-semibold rounded-md shadow focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
                    disabled={currentLoanFolder?.toLowerCase() === LoanCancelFolder.toLowerCase() || comment.length === 0 || isLoanReadOnly}
                    onClick={() => setShowRemoveAuConfirm(true)}
                >Cancel Loan</button>

                <ConfirmPrompt
                    visible={showRemoveAuConfirm}
                    message="Are you sure you want to cancel this loan?"
                    confirmText="Yes"
                    cancelText="No"
                    onCancel={() => setShowRemoveAuConfirm(false)}
                    onConfirm={cancelLoan}
                />
            </div>
        );
    }

    return (
        <div className="bg-white p-6 mb-6 rounded-lg shadow-sm border border-gray-100">
            <div className="flex justify-between">
                <div className="flex items-center">
                    <h3 className="m-0">Cancel Loan</h3>
                </div>
                {renderCancelLoanButton()}
            </div>
            {renderCancelLoanForm()}
            <div className="flex justify-end">
                {renderCancelLoanButton()}
            </div>
        </div>
    );
};

export default CancelLoan;
